import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useSeo } from '@/lib/seo';

export default function NotFoundPage() {
  useSeo({ title: '404 | A Guy Who Hunts', description: 'Page not found.' });
  return (
    <div className="mx-auto max-w-xl px-4 py-24 text-center">
      <p className="kicker">404</p>
      <h1 className="font-serif text-5xl tracking-tight mt-2">Off-trail.</h1>
      <p className="mt-3 text-[hsl(var(--muted-foreground))]">
        Whatever you were looking for isn’t here. It might have moved, or it might have never existed.
      </p>
      <div className="mt-6">
        <Link to="/">
          <Button>Back to home</Button>
        </Link>
      </div>
    </div>
  );
}
